/**
 * DCALGeneratorPage - DCAL Generator with Modern Layout
 *
 * Sub-tabs (Heat Profile, Test Repository, DCAL Generator, Coil Configurator), then DCAL list card and table.
 */

import React from 'react';
import DcalPage from '../../components/DCAL/DcalPage';
import TechnicalSubTabs from './TechnicalSubTabs';
import './HeatProfilePage.css';
import './DCALGeneratorPage.css';

const DCALGeneratorPage = () => (
    <div className="dcal-generator-page heat-profile-page">
        <TechnicalSubTabs />
        <div className="dcal-generator-content-wrapper heat-profile-content-wrapper">
            <DcalPage embeddedInModernLayout />
        </div>
    </div>
);

export default DCALGeneratorPage;
